import qs from 'query-string'
import {useLocation} from 'react-router'

export function useQuery<T extends Record<string, unknown>>() {
  const {search} = useLocation()
  return qs.parse(search) as unknown as T
}
